module.exports = __webpack_public_path__ + "img/cellProximity_thumb.ff21845b.png";